// extracted by mini-css-extract-plugin
module.exports = {"starColor":"_3jZvtn_F","stars":"_3G0dI6a0"};